import Typography from "@/Utility/Typography";
import {
  getWorkItemStatusCategoryBadgeStyle,
  getWorkItemStatusCategoryLabel,
} from "@/constants/workItemStatusCategoryTheme";

/**
 * Pill badge for a work-item `statusCategory` (New, Estimations, In Progress, …).
 */
const WorkItemStatusCategoryBadge = ({ category, label, className = "", showLabel = true }) => {
  const displayLabel =
    label != null && String(label).trim() !== ""
      ? String(label).trim()
      : getWorkItemStatusCategoryLabel(category);

  return (
    <Typography
      variant="span2"
      component="span"
      className={`inline-flex items-center rounded border px-2 py-0.5 text-xs font-medium ${className}`}
      style={getWorkItemStatusCategoryBadgeStyle(category)}
    >
      {showLabel ? displayLabel : null}
    </Typography>
  );
};

export default WorkItemStatusCategoryBadge;
